<fl-toast />
<fl-layout-ui
  [breadcrumbs]="layoutBreadcrumbService.breadcrumbs()"
  [vessels]="navFleetVessels()"
  [isLoadingVessels]="isLoadingVessels()"
  [fleets]="fleets()"
  [selectedFleetIds]="selectedFleetIds()"
  [timezone]="timezone()"
  [notifications]="fleetNotifications()"
  [filteredOutNotificationCount]="filteredOutNotificationCount()"
  [isFullscreen]="isFullscreen()"
  [user]="currentUser()"
  [userRole]="currentUserRole()"
  [userCustomRoleName]="userCustomRoleName()"
  [sideMenuItems]="sideMenuItems()"
  [licenses]="licenses()"
  [permissions]="permissions()"
  [selectedVesselId]="vesselId()"
  [tenant]="tenant()"
  [userCompanyName]="userCompanyName()"
  [isSideMenuMinimized]="isSideMenuMinimized()"
  (isSideMenuMinimizedChange)="layoutService.setIsSideMenuMinimized($event)"
  (selectedVesselIdChange)="onVesselSelected($event)"
  (selectedFleetIdsChange)="fleetFilterService.setSelectedFleetIds($event)"
  (logoutClick)="onLogout()"
  (consentClick)="consentService.show(true)"
  (notificationsRead)="layoutNotificationsService.updateSeenNotifications()"
/>
